import {

    SET_SUSCRIPTIONS,
    SET_APPLY_PROMOCODE,
    SET_SUSCRIPTION_ORDER_ID,
    CLEAR_SUSCRIPTION_STATUS,
    SET_SUBSCRIPTIONS

} from '../../util/actionTypes';
const initialState = { suscriptionStatus: [], subscriptions: [], isLoading: true };

const packageReducer = (state = initialState, action) => {

    switch (action.type) {
        case SET_APPLY_PROMOCODE:
            return {
                ...state,
                promoCodeData: action.payload,
            };
        case SET_SUSCRIPTION_ORDER_ID:
            return {
                ...state,
                suscriptionOrderId: action.payload,
            };

        case SET_SUSCRIPTIONS:
            console.log('action', action.payload)
            return {
                ...state,
                suscriptionStatus: action.payload,
                isLoading: false,
            };
        case SET_SUBSCRIPTIONS:
            return {
                ...state,
                allSubscriptions: action.payload.allSubscriptions,
                activeSubscriptions: action.payload.activeSubscriptions,
                activePlans: action.payload.activePlans,
                accessiblePlans: action.payload.accessiblePlans ?? [],
                isLoading: false,
                error: null
            };

        case CLEAR_SUSCRIPTION_STATUS:
            return {
                ...state,
                suscriptionStatus: null,
                suscriptionOrderId: null,
            };
        case "CLEAR_ORDER_ID":
            return {
                ...state,
                suscriptionOrderId: null
            };

        default:
            return state;
    }
};

export default packageReducer;
